export default  [
    {
        VALUE:'Benchmark Title –2007 Randall St. Dallas, TX 75201 Attn: Greg Garza – P: 214-485-8638 E:ggarza@bmktitle.com',
        LABEL:'Benchmark - Dallas, TX - Greg Garza'
    },{
        VALUE:'Capital Title – 8333 Douglas Avenue Suite 1525, Dallas, Texas 75225 Attn: Bob Blanshard – P: 214-396-8071 E: BBlanshard@ctot.com',
        LABEL:'Capital Title - Dallas, TX - Bob Blanshard'
    },{
        VALUE:'Fidelity National Title –1125 Executive Circle, Suite 220, Irving, TX 75038 Attn: Billy Thomas – P: 817-829-5008 E: billy.thomas@fnf.com',
        LABEL:'Fidelity - Irving, TX - Billy Thomas'
    },{
        VALUE:'Fidelity National Title - 1125 Executive Circle, Suite 220 Irving, TX 75038 Attn: Amanda Brower – P: 972-435-4330 E: Amanda.brower@fnf.com',
        LABEL:'Fidelity - Irving, TX - Amanda Brower'
    },{
        VALUE:'Kensington Vanguard - 5005 LBJ Freeway Suite 200 Dallas, TX 75244 Attn Phil Prounh –  P: 817.807.7197 E: Pprounh@kvnational.com',
        LABEL:'Kensington - Dallas, TX - Phil Prounh'
    },{
        VALUE:'Madison Title - 13101 Preston Road Suite 300, Dallas TX 75240 Attn: Samuel Herskovits – P: (214) 461-4817 E: SHerskovits@madisontitle.com',
        LABEL:'Madison - Dallas, TX - Samuel Herskovits'
    },{
        VALUE:'Old Republic - 4200 Westheimer Road, Suite 150 Houston, Texas 77027 Attn: Harry Klein – P: (713) 482-2809 E: hklein@oldrepublictitle.com',
        LABEL:'Old Republic - Houston, Texas - Harry Klein'
    },{
        VALUE:'Other',
        LABEL:'Other'
    }
]